export enum PITCH_EVENT_TYPE {
  OPEN = 1,
  INVITE_ONLY = 2,
}
